import OurValue from "../components/OurValue.jsx"
import AboutUs from "../components/AboutUs.jsx"
import ImageSlider from "../components/ImageSlider.jsx"


function AboutUsPage() {

    return (
        <>
            <AboutUs/>
            <OurValue />
            <ImageSlider/>
        </>
    )
}

export default AboutUsPage